import { Component, ViewChild } from "@angular/core";
import { VTabComponent } from "@app/directives/_layout/v-tabs/v-tab.component";
import { ContextualSpeedingByRoadComponent } from "./contextual-speeding-by-road/contextual-speeding-by-road.component";
import { ContextualSpeedingByVehicleComponent } from "./contextual-speeding-by-vehicle/contextual-speeding-by-vehicle.component";
import './contextual-speeding-settings-manager.component.scss';
import { ContextualSpeedingTab } from "./enums/contextual-speeding-tab";
import { ContextualSpeedingTabButton } from "./models/contextual-speeding-tab-button";

@Component({
    selector: 'contextual-speeding-settings-manager',
    template: require('./contextual-speeding-settings-manager.component.html')
})
export class ContextualSpeedingSettingsManagerComponent {
    Tab = ContextualSpeedingTab;
    selectedTab: ContextualSpeedingTab;

    tabButtons: ContextualSpeedingTabButton[] = [
        {
            tab: ContextualSpeedingTab.ByVehicle,
            displayText: 'ContextualSpeedingSettingsManager.AddVehicleType',
            icon: 'add',
            action: () => this.byVehicle.showEditor()
        },
        {
            tab: ContextualSpeedingTab.ByRoad,
            displayText: 'ContextualSpeedingSettingsManager.AddRoadSegment',
            icon: 'add',
            action: () => this.byRoad.showEditor()
        }
    ];

    get tabButton(): ContextualSpeedingTabButton {
        return this.tabButtons.find(x => x.tab == this.selectedTab);
    }

    @ViewChild('byVehicle') byVehicle: ContextualSpeedingByVehicleComponent;
    @ViewChild('byRoad') byRoad: ContextualSpeedingByRoadComponent;

    onTabSelect(tab: VTabComponent): void {
        this.selectedTab = tab.tabId as ContextualSpeedingTab;
    }
}
